import * as React from "react";
import { ErrorsProps, CustomComponentProps } from "react-redux-form";

export interface ValidationMessageProps extends ErrorsProps, CustomComponentProps { }

class ValidationMessage extends React.PureComponent<ValidationMessageProps, any> {
  render() {
    return <div className="form-control-feedback">{this.props.children}</div>;
  }
}

export default ValidationMessage;



// WEBPACK FOOTER //
// ./src/components/Controls/ValidationMessage.tsx